import { t } from "i18next";

/** Axios-style error carrying a server validation message in its response body. */

/**
 * Derives a human-readable, translated error message from a failed reminder save.
 * Maps the backend field-length validation error to a friendly string and falls
 * back to a generic save-failure message for any other error.
 */
export function getSaveErrorMessage(error) {
  var _response$data$messag, _response;
  var rawMessage = (_response$data$messag = error === null || error === void 0 || (_response = error.response) === null || _response === void 0 || (_response = _response.data) === null || _response === void 0 ? void 0 : _response.message) !== null && _response$data$messag !== void 0 ? _response$data$messag : "";
  var tooLongMatch = rawMessage.match(/at most (\d+) characters/i);
  if (tooLongMatch) {
    var count = Number(tooLongMatch[1]);
    if (/title/i.test(rawMessage)) {
      return t("error.task_title_too_long", {
        defaultValue: "Task title must be at most {{count}} characters.",
        count: count
      });
    }
    return t("error.task_description_too_long", {
      defaultValue: "Task description must be at most {{count}} characters.",
      count: count
    });
  }
  return t("error.task_save_failed", {
    defaultValue: "Couldn't save the task. Please try again."
  });
}